import { useState, useEffect } from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import { ShortListedPropertyCard } from "../../../../shadcn/components/custom/ShortListedPropertyCard";
import { useSelector } from "react-redux";
import { getAllProperties, getWatermarkedImgixUrl } from "services";
import { useRouter } from "next/router";

interface ShortListedPropertyItems {
  subAssetType?: string;
  price?: string;
  address?: string;
  imageLink?: string;
  propertyLink?: string;
  propertyDateType?: string;
}

export default function ShortListedProperty() {
  const router = useRouter();
  const [shortlistedPropertiesData, setShortlistedPropertiesData] = useState<
    ShortListedPropertyItems[]
  >([]);
  const isLoggedIn = useSelector((state: any) => state.auth.user);
  const shortlistedProperties = useSelector((state: any) => {
    return state.auth?.user?.profile?.meta?.shortlisted_properties;
  });

  const getProperties = async () => {
    const data: any = await getAllProperties({
      apiConfig: {
        includeRelations: [
          "locality",
          "city",
          "sub_asset_type",
          "bank",
          "images",
          "sub_asset_type_images",
        ],
        includeMutations: ["state", "asset", "images"],
        includeFacets: false,
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [
        {
          attribute: "uuid",
          op: "in",
          value: shortlistedProperties ? shortlistedProperties : [],
        },
      ],
    });

    const filteredData =
      [...(data.data || [])].map((item: any) => ({
        subAssetType: item?.sub_asset_type?.name,
        price: item?.reserve_price,
        address: item?.locality?.name
          ? `${item?.locality?.name}, ${item?.city?.name}`
          : item.city.name,
        imageLink:
          item?.images.length > 0
            ? getWatermarkedImgixUrl(
                `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${
                  item?.images[0]?.path_to_file?.split(".com/")[1]
                }?auto=format`,
              )
            : item?.sub_asset_type_images.length > 0
            ? getWatermarkedImgixUrl(
                `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${
                  item?.sub_asset_type_images[0]?.path_to_file?.split(
                    ".com/",
                  )[1]
                }?auto=format`,
              )
            : "/ShortListedProperty.png",
        propertyLink: `/auction-properties/${item?.listing_id}`,
        propertyDateType: item.property_date_type,
      })) || [];
    setShortlistedPropertiesData(filteredData);
  };

  useEffect(() => {
    if (isLoggedIn) {
      getProperties();
    }
  }, [shortlistedProperties, isLoggedIn]);

  if (isLoggedIn && shortlistedPropertiesData.length > 0) {
    return (
      <>
        <div className="hidden lg:flex ">
          <div className="w-full px-customPadding mt-20 py-[50px]  2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
            {/* Heading */}
            <div className="flex items-center">
              <p className="font-spaceGrotesk font-normal text-web-h2 leading-[57px] text-brand-textBlack">
                SHORTLISTED PROPERTIES
              </p>
              <Button
                onClick={() => router.push("/dashboard/shortlisted")}
                className="ml-auto h-[60px] w-[187px] font-openSans font-semibold text-[22px] leading-[30px] text-brand-textWhite"
              >
                View all
              </Button>
            </div>
            {/* Card */}
            <div className="grid grid-cols-3 gap-11 gap-y-[50px] mt-[67px] ">
              {" "}
              {shortlistedPropertiesData.slice(0, 6).map((item, index) => (
                <div key={`shortlisted_${index}`}>
                  <ShortListedPropertyCard
                    price={item?.price}
                    subAssetType={item?.subAssetType}
                    imageLink={item?.imageLink}
                    address={item?.address}
                    propertyLink={item?.propertyLink}
                    propertyDateType={item?.propertyDateType}
                    subAssetTypeBgcolor="bg-white"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return null;
  }
}
